import { IconSize } from '@icons/types';
import { BorderedInputSizeVariant } from '@primitives/BorderedInput/types';

export const inputSizeToIconSize: Record<BorderedInputSizeVariant, IconSize> = {
    small: 'xs',
    medium: 'sm',
    large: 'md',
    'full-width': 'xs',
};
